import { Outlet } from 'react-router-dom';

import { values } from 'lodash-es';

import { MainLayoutBase } from '@/layout/mainLayout/MainLayoutBase';
import Header from '@/layout/mainLayout/header';
import type { LookoRouteObject } from '@/router/LookoRouteObject';

// 업로드 설정
export const 업로드_온보딩_라우터 = {
  카페24_기본_설정: {
    path: '/settings/assistant/cafe24',
    async lazy() {
      const { default: Page } = await import('@/router/업로드_온보딩/카페24_기본_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '카페24 기본 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,
  카페24_상품분류_설정: {
    path: '/settings/category/cafe24',
    async lazy() {
      const { default: Page } = await import('@/router/업로드_온보딩/카페24_온보딩_상품분류_연결_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '카페24 상품분류 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,
};

export const 업로드_온보딩_루트: LookoRouteObject = {
  path: '/',
  element: (
    <MainLayoutBase appBar={<Header />}>
      <Outlet />
    </MainLayoutBase>
  ),
  children: values(업로드_온보딩_라우터),
};
